import BaseUISystem from './BaseUISystem';
import Game from '../../Game';
import GDPRMenuHandler from './Menu/GDPRMenuHandler';

export default class PreloadUISystem extends BaseUISystem {
    public init(): void {
        this.handlers = [];

        if (!Game.state.getState().playerState.gdprCompliance) {
            this.handlers.push(new GDPRMenuHandler(this));
        }
    }
}
